<template>
  <div>
    <header>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
      <!-- Include CSS do MDB -->
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/mdb-ui-kit/6.4.1/mdb.min.css">
    </header>
    <div class="title-container">
      <h3 class="title">API {{ nomeCatalogo }}</h3>
    </div>

    <div class="container container-bkg mt-3" style="max-width: 1011px !important;">
      <div class="btn-group d-flex justify-content-center" role="group" style="margin-left: 10px !important;">
        <button v-for="tab in tabsVisiveis" :key="tab.key" type="button" class="btn btn-primary top-button"
          :class="{ active: abaAtiva === tab.key }" data-mdb-ripple-init @click="onClickTab(tab)">
          {{ tab.label }}
        </button>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <component :is="component" v-bind="propsFilho" @setando-menu-ativo="setandoMenuAtivo"
            @on-action-in-menu="onActionInMenu" @salvar-dados="salvarDados" @confirmacao-publicar="confirmacaoPublicar"
            @open-modal="openModal" @setar-icone="setarIcone" @open-modal-rest-soap="openModalRestSoap"
            @open-modal-add-item-historico="openModalAddItemHistorico" @atualizar-listas="onAtualizarListas"
            @atualizar-autenticacao="onAtualizarAutenticacao" />
        </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Especificacoes from './Especificacoes.vue';
import RestSoap from './RestSoap.vue';
import Historico from './Historico.vue';
import * as ajaxUtils from '@/utils/ajax';
import * as loaderUtils from '@/utils/loader'
import * as alertUtils from '@/utils/alert';
import 'mdb-ui-kit'; // Importando o JavaScript do MDB


export default {
  name: 'ManutencaoCatalogoServico',

  components: {
    Especificacoes,
    RestSoap,
    Historico
  },

  data() {
    return {
      nomeCatalogo: '',
      clone: false,

      component: Especificacoes,
      abaAtiva: 'especificacoes',

      idCatalogo: '',
      listas: {},

      listaItensHistorico: [],

      tabsBase: [
        { key: 'especificacoes', label: 'ESPECIFICAÇÕES', component: Especificacoes },
        { key: 'rest', label: 'REST', component: RestSoap },
        { key: 'soap', label: 'SOAP', component: RestSoap },
        { key: 'itens-historico', label: 'HISTORICO', component: Historico }
      ]
    };
  },

  async mounted() {
    this.idCatalogo = this.$route.params.idCatalogo;
    this.clone = String(this.idCatalogo).includes('-clone');

    await this.pesquisar();

    // aba inicial
    this.abaAtiva = 'especificacoes';
    this.component = 'Especificacoes';
  },

  computed: {
    possuiSoap() {
      var menus = (this.listas && this.listas.listaMenuCatalogoApi)
        ? this.listas.listaMenuCatalogoApi
        : [];

      return Array.isArray(menus) && menus.some(function (m) {
        return String(m.tipo) === 'S';
      });
    },

    tabsVisiveis() {
      var self = this;

      return this.tabsBase.filter(function (t) {
        if (t.key === 'itens-historico' && !self.clone) return false;
        if (t.key === 'soap' && !self.possuiSoap && !self.clone) return false;

        return true;
      });

    },

    propsFilho() {

      var listaAut = (this.listas && this.listas.listaAutenticacaoCatalogoApi)
        ? this.listas.listaAutenticacaoCatalogoApi
        : [];

      var listaMenu = (this.listas && this.listas.listaMenuCatalogoApi)
        ? this.listas.listaMenuCatalogoApi
        : [];

      var base = {
        clone: this.clone,
        listas: this.listas,
        idCatalogo: this.idCatalogo,
        listaAutenticacaoCatalogoApi: listaAut,
        listaMenuCatalogoApi: listaMenu
      };

      if (this.abaAtiva === 'itens-historico') {
        return Object.assign({}, base, {
          listaItensHistorico: this.listaItensHistorico
        });
      }

      if (this.abaAtiva === 'rest' || this.abaAtiva === 'soap') {
        return Object.assign({}, base, {
          tipo: String(this.abaAtiva).toUpperCase(),
          selectedListasRestSoap: this.selectedListasRestSoap || ''
        });
      }

      return base;
    }
  },




  watch: {

    possuiSoap(novo) {
      if (!novo && this.abaAtiva === 'soap') {
        this.abaAtiva = 'especificacoes';
        this.component = 'Especificacoes';
      }
    },


    clone(novo) {
      if (!novo && this.abaAtiva === 'itens-historico') {
        this.abaAtiva = 'especificacoes';
        this.component = 'Especificacoes';
      }
    }
  },

  methods: {
    async onClickTab(tab) {
      this.abaAtiva = tab.key;
      this.component = tab.component;

      if (tab.key === 'itens-historico') {
        await this.pesquisar();
        this.component = 'Historico';
      }

      if (tab.key === 'rest' || tab.key === 'soap') {
        this.onActionInMenu();
      }
    },

    async pesquisar() {
      const urlApi =
        '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consulta-catalogo/' +
        this.idCatalogo;

      const data = await ajaxUtils.get(urlApi, false);
      if (!data) return;

      this.listas = data;

      let nome = data.nome || '';
      if (nome.includes('-clone')) nome = nome.replace('-clone', ' Clone');
      this.nomeCatalogo = nome;

    },

    setandoMenuAtivo(payload) {
      if (!payload) return;

      const id = typeof payload === 'string' ? payload : payload.id;
      if (!id) return;

      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    onAtualizarListas(payload) {
      if (!payload) return;

      if (payload.listaMenuCatalogoApi) {
        this.listas = Object.assign({}, this.listas, {
          listaMenuCatalogoApi: payload.listaMenuCatalogoApi
        });
        return;
      }

      this.listas = payload;
    },


    onAtualizarAutenticacao(lista) {

      this.listas = Object.assign({}, this.listas, {
        listaAutenticacaoCatalogoApi: lista
      });
    },
    async confirmacaoPublicar() {
      loaderUtils.addLoarder();
      alertUtils.alertConfirmacaoTop("Nova versão da API?").then(
        (result) => {
          if (result) {
            this.publicar("S");
          } else {
            this.publicar("N");
          }
        }
      );
    },


    async publicar(novaVersao) {
      loaderUtils.addLoarder();
      let urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/publicar/' + novaVersao + '/' + this.idCatalogo;
      let retorno = await ajaxUtils.get(urlApi, false);
      if (retorno == 'OK') {
        alertUtils.alertSuccess("Publicado com sucesso!");
        let idCatalogoAux = this.$route.params.idCatalogo;
        idCatalogoAux = idCatalogoAux.replace("-clone", "");
        this.carregarGeral(idCatalogoAux);
      } else {
        alertUtils.alertError("Erro ao publicar a API!");
      }
      loaderUtils.removeLoader();

      /*
      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/publicar/' + novaVersao + '/'+ this.idCatalogo;
      method = 'POST';
      
      requestOptions = {
        method: method,
        headers:  {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      };

      
      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              alertUtils.alertSuccess("Publicado com sucesso!");
              await this.pesquisar('V');
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(() => {
            this.showList = true;
            loaderUtils.removeLoader();      
          })
          .catch((error) => {
            console.log(error)
            // alertUtils.alertError('Erro ao salvar!', 'Fechar');
          }).finally(() => 'loaderUtils.removeLoader()');
         
      } catch (error) {
        alertUtils.alertError('Erro ao publicar:'+ error);
      }
*/
      this.$router.push('/consulta-catalogo');
      window.location.reload();

    },

    async carregarGeral(idCatalogoAux) {
      this.idCatalogo = idCatalogoAux;



      this.pesquisar('V');

      setTimeout(() => {
        this.setarIcone();

        if (this.clone === 'false') $('td button').prop("disabled", true);

        if (this.clone === false) {
          $('.trash-icon').css("display", "none");
          $('.pen-icon').css("display", "none");
        }
      }, 1000); // 1000 milissegundos = 1 segundo
    },


    onActionInMenu() { },
    salvarDados() { },
    openModal() { },
    setarIcone() { },
    openModalRestSoap() { },
    openModalAddItemHistorico() { }
  }
};
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);

  display: none;
  align-items: center;
  justify-content: center;
}

.loader.show {
  display: flex;
}


@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/manutencao/style.css';
</style>
